import { useEffect } from "react";

/**
 * Updates document <title> and meta description/OG tags for each page.
 * Called once per page component on mount.
 */
export default function useSEO({ title, description, url }) {
  useEffect(() => {
    const siteName = "NaN Studio";
    const fullTitle = title ? `${title} – ${siteName}` : siteName;

    document.title = fullTitle;

    const setMeta = (selector, value) => {
      let el = document.querySelector(selector);
      if (!el) {
        const [attr, attrVal] = selector.includes("property")
          ? ["property", selector.match(/content="([^"]+)"/)?.[1]]
          : ["name", selector.match(/content="([^"]+)"/)?.[1]];
        el = document.createElement("meta");
        document.head.appendChild(el);
      }
      if (el) el.setAttribute("content", value);
    };

    if (description) {
      const desc = document.querySelector('meta[name="description"]');
      if (desc) desc.setAttribute("content", description);

      const ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute("content", description);

      const twDesc = document.querySelector('meta[name="twitter:description"]');
      if (twDesc) twDesc.setAttribute("content", description);
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", fullTitle);

    const twTitle = document.querySelector('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute("content", fullTitle);

    if (url) {
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.setAttribute("href", url);

      const ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) ogUrl.setAttribute("content", url);
    }

    // Restore defaults on unmount
    return () => {
      document.title = siteName;
    };
  }, [title, description, url]);
}
